export default class SmartphoneNavigateEvent {
    constructor(type, screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions) {
        this.type = type;
        this.screenType = screenType;
        this.screen = screen;
        this.autocenter = autoCenter;
        this.priority = priority;
        this.needsOverlay = needsOverlay;
        this.openUnderCurrent = openUnderCurrent;
        this.animationType = animationType;
        this.animationOptions = animationOptions;
    };
}

SmartphoneNavigateEvent.SMARTPHONE_SHOW_REQUEST = "SmartphoneNavigateEvent.SMARTPHONE_SHOW_REQUEST";
SmartphoneNavigateEvent.SMARTPHONE_HIDE_REQUEST = "SmartphoneNavigateEvent.SMARTPHONE_HIDE_REQUEST";

SmartphoneNavigateEvent.OPEN_SCREEN_REQUEST = "smartphoneOpenScreenRequest";
SmartphoneNavigateEvent.GOTO_SCREEN_REQUEST = "smartphoneGotoScreenRequest";
SmartphoneNavigateEvent.CLOSE_SCREEN_REQUEST = "smartphoneCloseScreenRequest";
SmartphoneNavigateEvent.CLOSE_ALL_SCREENS_REQUEST = "smartphoneCloseAllScreensRequest";
SmartphoneNavigateEvent.POP_UP_REQUEST = "smartphonePopUpRequest";
SmartphoneNavigateEvent.CLOSE_POP_UP_REQUEST = "smartphoneClosePopUpRequest";